import React from 'react';

// Small inline link rendered in the header of player panels / modals.
// Toggles the current player in the scratchpad and flips its label between
// "Add to Scratchpad" and "Remove from Scratchpad" based on current state.
const AddToScratchpadLink = ({ playerData, onToggleScratchpad, isInScratchpad }) => {
  if (!onToggleScratchpad || !playerData?.playerId) return null;
  const inPad = isInScratchpad ? isInScratchpad(playerData) : false;

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onToggleScratchpad(playerData);
      }}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        background: 'transparent',
        border: 'none',
        color: '#a78bfa',
        fontSize: '0.75rem',
        cursor: 'pointer',
        padding: '2px 6px',
        textDecoration: 'underline',
      }}
      title={inPad ? 'Remove from scratchpad' : 'Add to scratchpad'}
      onMouseEnter={(e) => { e.currentTarget.style.color = '#c4b5fd'; }}
      onMouseLeave={(e) => { e.currentTarget.style.color = '#a78bfa'; }}
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
        <path d="M5 4a2 2 0 0 1 2-2h9l4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path d="M9 9h6M9 13h6M9 17h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        {inPad && (
          <path d="M5 5l14 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        )}
      </svg>
      <span>{inPad ? 'Remove from Scratchpad' : 'Add to Scratchpad'}</span>
    </button>
  );
};

export default AddToScratchpadLink;
